import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import ErrorBoundary from '../components/core/ErrorBoundary'
import { reportFailure } from '../services/report-failure'
import { currentSentryFeature } from '../services/sentry'

// Non-production only (SentryBindings never mounts it in production, and mounts
// it only once the signed-in user is identified, so events carry user_email/plan):
// `?sentry_test=export|report_job|load|api|render` on any signed-in page fires one
// tagged test event, so the Slack alert rules can be checked end to end.
const REPORTED_SCENARIOS = ['export', 'report_job', 'load', 'api']

const ThrowOnRender = () => {
  throw new Error('Sentry test: render crash')
}

const SentryTestTrigger = () => {
  const [searchParams] = useSearchParams()
  const scenario = searchParams.get('sentry_test')
  const feature = currentSentryFeature() || 'project'

  useEffect(() => {
    if (!REPORTED_SCENARIOS.includes(scenario)) return
    reportFailure({
      feature,
      scenario,
      error: new Error(`Sentry test: ${scenario} failure`),
      jobId: scenario === 'report_job' ? 'sentry-test-job' : undefined,
      exportType: scenario === 'export' ? 'pdf' : undefined,
      tags: { sentry_test: 'true' }
    })
  }, [scenario])

  // Throws inside a real feature boundary, exercising the same catch path.
  if (scenario !== 'render') return null
  return (
    <ErrorBoundary feature={feature}>
      <ThrowOnRender />
    </ErrorBoundary>
  )
}

export default SentryTestTrigger
